<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="form_no">TNA Form No.</label>
                                <input type="text"
                                       v-model="search_data.form_no" id="form_no"
                                       name="form_no"
                                       class="form-control form-control-sm"
                                       placeholder="Search by TNA Form No"
                                />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="household_number">Household Number</label>
                                <input type="text"
                                       v-model="search_data.household_number" id="household_number"
                                       name="household_number"
                                       class="form-control form-control-sm"
                                       placeholder="Search by HH No"
                                />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="name">Household Head Name</label>
                                <input
                                        type="text"
                                        v-model="search_data.name" id="name" name="name"
                                        class="form-control form-control-sm"
                                        placeholder="Search by Name"
                                />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_village_id">Village</label>
                                <select
                                        v-model="search_data.c_village_id"
                                        id="c_village_id" name="c_village_id"
                                        class="form-control form-control-sm"
                                >
                                    <option selected :value="''">Select a village</option>
                                    <option
                                            v-for="(village, index) in villages"
                                            :key="index"
                                            :value="village.id"
                                    >{{ village.id }} : {{ village.desc }}
                                    </option
                                    >
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_mouza_id">Mouza</label>
                                <select
                                        v-model="search_data.c_mouza_id"
                                        class="form-control form-control-sm"
                                        name="c_mouza_id"
                                        id="c_mouza_id"
                                >
                                    <option selected :value="''">Select a Mouza</option>
                                    <option
                                            v-for="(mouza, index) in mouzas"
                                            :key="index"
                                            :value="mouza.id"
                                    >{{ mouza.id }} : {{ mouza.desc }}
                                    </option
                                    >
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_training_trade_id">Trade</label>
                                <select v-model="search_data.c_training_trade_id"
                                        id="c_training_trade_id" class="form-control form-control-sm" name="c_training_trade_id">
                                    <option :value="''" selected>Select Training Trade</option>
                                    <option v-for="(trade, index) in trades" :key="index" v-bind:value="trade.id">
                                        {{ trade.id }} : {{ trade.desc }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="batch_no">Batch No</label>
                                <select class="form-control form-control-sm" v-model="search_data.batch_no" id="batch_no" name="batch_no">
                                    <option :value="''" selected>Select Batch no.</option>
                                    <option value="01">01</option>
                                    <option value="02">02</option>
                                    <option value="03">03</option>
                                    <option value="04">04</option>
                                    <option value="05">05</option>
                                    <option value="06">06</option>
                                    <option value="07">07</option>
                                    <option value="08">08</option>
                                    <option value="09">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                    <option value="18">18</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                    <option value="21">21</option>
                                    <option value="22">22</option>
                                    <option value="23">23</option>
                                    <option value="24">24</option>
                                    <option value="25">25</option>
                                </select>
                            </div>
                        </div>
                        <button
                                @click.prevent="search"
                                class="btn btn-success btn-sm mt-2"
                        >
                            Search
                        </button>
                    </form>
                </b-card>

                <b-card>
                    <div v-if="trainees.total > 0" class="row mb-2">
                        <div class="col-sm-12">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ trainees.total }}</span>
                            <download-excel
                                    class="btn btn-light mr-2 float-right"
                                    :fetch="fetchData"
                                    :fields="followup_fields"
                                    :meta="json_meta"
                                    :before-generate="startDownload"
                                    :before-finish="finishDownload"
                                    worksheet="Followup"
                                    name="followup.xls">
                                Download Excel
                            </download-excel>

                            <button class="btn btn-light float-right mr-1" @click="dowonloadPdf">
                                <div v-if="spinner" class="spinner-border spinner-border-sm text-muted" style="margin-bottom : 2px;">
                                </div>
                                Download PDF
                            </button>
                            <b-dropdown variant="default" style=" background-color: #d4d4d4; border-color: #8c8c8c;">
                                <template v-slot:button-content>
                                    <i class="fa fa-cog"></i>
                                </template>
                                <b-dropdown-form style="width: 207px !important; overflow-y: auto">
                            <span v-for="(checkboxArray, index) in checkboxArrays" :key="index" class="ml-3">
                                <input type="checkbox" v-model="selected" :value="checkboxArray" :id="checkboxArray">&nbsp;{{ checkboxArray }} <br>
                            </span>
                                </b-dropdown-form>
                            </b-dropdown>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th v-if="isVisible('Form No.')">Form No.</th>
                                <th v-if="isVisible('Household Number')">Household Number</th>
                                <th v-if="isVisible('Name')">Name</th>
                                <th v-if="isVisible('NID')">NID(ID Type)</th>
                                <th v-if="isVisible('Mobile')">Mobile</th>
                                <th v-if="isVisible('Gender')">Gender</th>
                                <th v-if="isVisible('Father Name')">Father Name</th>
                                <th v-if="isVisible('Mother Name')">Mother Name</th>
                                <th v-if="isVisible('Village')">Village</th>
                                <th v-if="isVisible('Mouza')">Mouza</th>
                                <th v-if="isVisible('Rep Name')">Rep. Name</th>
                                <th v-if="isVisible('Rep Father Name')">Rep. Father/Husband Name</th>
                                <th v-if="isVisible('Rep Mother Name')">Rep Mother Name</th>
                                <th v-if="isVisible('Rep Relation')">Rep Relation</th>
                                <th v-if="isVisible('Rep DOB')">Rep DOB</th>
                                <th v-if="isVisible('Rep Gender')">Rep Gender</th>
                                <th v-if="isVisible('Rep NID')">Rep NID</th>
                                <th v-if="isVisible('Rep Mobile')">Rep Mobile</th>
                                <th v-if="isVisible('Field Book')">Field Book</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(trainee, index) in trainees.data" :key="index">
                                <td>{{ trainees.from + index }}</td>
                                <td v-if="isVisible('Form No.')">{{ trainee.form_no }}</td>
                                <td v-if="isVisible('Household Number')">{{ trainee.household_number }}</td>
                                <td v-if="isVisible('Name')">
                                    <router-link :to="{
                          name: 'traineeView',
                          params: { trainee_id: trainee.id }}" tag="a" title="Trainee Details" target="_blank">

                            <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                                <span v-if="image.file_tag === '1'">
                                  <img class="rounded-circle" :src="image.name" alt="" width="30px" height="30px"/>
                                </span>
                            </span>
                                        {{ trainee.name }}
                                    </router-link>
                                </td>
                                <td v-if="isVisible('NID')">{{ trainee.nid }}({{ trainee.id_type }})</td>
                                <td v-if="isVisible('Mobile')">{{ trainee.mobile }}</td>
                                <td v-if="isVisible('Gender')">{{ trainee.gender.desc }}</td>
                                <td v-if="isVisible('Father Name')">{{ trainee.father_husband_name }}</td>
                                <td v-if="isVisible('Mother Name')">{{ trainee.mother_name }}</td>
                                <td v-if="isVisible('Village')">{{ trainee.village.desc }}</td>
                                <td v-if="isVisible('Mouza')">{{ trainee.mouza.desc }}</td>
                                <td v-if="isVisible('Rep Name')">
                  <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                        <span v-if="image.file_tag === '2'">
                          <img class="rounded-circle" :src="image.name" alt="" width="30px" height="30px"/>
                        </span>
                    </span>
                                    {{ trainee.rep_name }}
                                </td>
                                <td v-if="isVisible('Rep Father Name')">{{ trainee.rep_father_husband_name }}</td>
                                <td v-if="isVisible('Rep Mother Name')">{{ trainee.rep_mother_name }}</td>
                                <td v-if="isVisible('Rep Relation')"><span v-if="trainee.family_relation !== null">{{ trainee.family_relation.desc }}</span>
                                </td>
                                <td v-if="isVisible('Rep DOB')">{{ trainee.rep_dob }}</td>
                                <td v-if="isVisible('Rep Gender')"><span v-if="trainee.rep_gender !== null">{{ trainee.rep_gender.desc }}</span>
                                </td>
                                <td v-if="isVisible('Rep NID')"><span v-if="trainee.rep_nid !== null">{{ trainee.rep_nid }}({{ trainee.rep_id_type }})</span>
                                </td>
                                <td v-if="isVisible('Rep Mobile')">{{ trainee.rep_mobile }}</td>
                                <td v-if="isVisible('Field Book')">{{ trainee.field_book_sl }}</td>
                                <td>
                                    <span>
                                        <router-link
                                                :to="{name: 'followupList',params: { trainee_id: trainee.id }}"
                                                tag="a"
                                                class="action-icon" title="Trainee Followup List"
                                                target="_blank">
                                            <i class="mdi mdi-format-list-bulleted addButton"></i>
                                        </router-link>
                                        <router-link
                                                :to="{name: 'followupComparison',params: { trainee_id: trainee.id }}"
                                                tag="a"
                                                class="action-icon" title="Trainee Followup Comparison"
                                                target="_blank">
                                            <i class="mdi mdi-format-list-bulleted editButton"></i>
                                        </router-link>
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <h5 v-if="trainees.total == 0" class="text-center text-secondary">
                        No Data Found
                    </h5>
                    <div class="float-right">
                        <pagination :data="trainees" :limit="2" @pagination-change-page="getResults"></pagination>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";
    import html2canvas from "html2canvas"
    import moment from "moment";
    import jsPDF from 'jspdf';
    import autoTable from 'jspdf-autotable';

    export default {
        page: {
            title: "Trainee List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Search Trainee",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Trainee",
                        active: true
                    }
                ],
                trainees: {},
                search_data: {
                    form_no: '',
                    household_number: '',
                    name: '',
                    c_village_id: '',
                    c_mouza_id: '',
                    c_training_trade_id: '',
                    batch_no: '',
                },
                spinner: false,
                villages: [],
                trades: [],
                mouzas: [],
                trainee: {},
                traineePdf: {},
                followup_fields: {
                    'Name of Trainee' : {
                        callback: (value) => {
                            return `${value.trainee.rep_name ? value.trainee.rep_name : value.trainee.name}`;
                        }
                    },
                    'Father`s Name' : {
                      callback: (value) => {
                        return `${value.trainee.rep_father_husband_name ? value.trainee.rep_father_husband_name : value.trainee.father_husband_name}`;
                      }
                    },
                    'Mother`s Name' : {
                      callback: (value) => {
                        return `${value.trainee.rep_mother_name ? value.trainee.rep_mother_name : value.trainee.mother_name}`;
                      }
                    },
                    'Mobile Number' : {
                      callback: (value) => {
                        return `${value.trainee.rep_mobile ? value.trainee.rep_mobile : value.trainee.mobile}`;
                      }
                    },
                    'Age':  'trainee.trainee_age',
                    'Village': 'trainee.village.desc',
                    'Mouza': 'trainee.mouza.desc',
                    'Training Trade' : 'desc',
                    'Training Duration': 'duration_days',
                    'Trade and Batch' : {
                      callback: (value) => {
                        return `${value.desc} - Batch No.: ${value.batch_no}`;
                      }
                    },
                    'Past Occupation': {
                        callback: (value) => {
                            return `${value.past_occupation ? value.past_occupation.desc : ''}`;
                         }
                    },
                    'Present Occupation': {
                      callback: (value) => {
                        return `${value.present_occupation ? value.present_occupation.desc : ''}`;
                      }
                    },
                    'Past Monthly Income': 'present_monthly_income',
                    'Present Monthly Income': 'present_monthly_income',
                    'Past Family Monthly Income': 'family_monthly_income',
                    'Present Family Monthly Income': 'family_monthly_income',
                    'Past Income from Training Trade': 'training_trade_desc',
                    'Present Income from Training Trade': 'training_trade_desc',
                    'Job holder': {
                      callback: (value) => {
                        return `${value.is_job_holder == 1 ? 'Yes' : 'No'}`;
                      }
                    },
                    'Job Description': 'job_description',
                    'is Inspire': 'is_inspire',
                    'Government Help': {
                      callback: (value) => {
                        return `${value.govt_help == 1 ? 'Yes' : 'No'}`;
                      }
                    },
                   'Government Help Description': 'govt_help_description',
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
                flag: false,
                checkboxArrays: ['Form No.', 'Name of Trainee', 'Name', 'NID', 'Mobile', 'Gender', 'Father Name', 'Mother Name', 'Village', 'Mouza', 'Rep Name', 'Rep Father Name', 'Rep Mother Name', 'Rep Relation', 'Rep DOB', 'Rep Gender', 'Rep NID', 'Rep Mobile', 'Field Book'],
                selected: ['Form No.', 'Household Number', 'Name', 'Father Name', 'Village', 'Rep Name', 'Rep Father Name'],
            };
        },


        mounted() {
            this.getCodes();
        },
        methods: {
            async dowonloadPdf() {
            this.spinner = true
            let response = await http.post("api/followup/report/download", this.search_data);
            var data = []
            try {
                response.data.trainees.forEach(function (value) {
                    data.push([
                        value.form_no,
                        value.trainee.rep_name ? value.trainee.rep_name : value.trainee.name,
                        value.trainee.rep_father_husband_name ? value.trainee.rep_father_husband_name : value.trainee.father_husband_name,
                        value.trainee.rep_mother_name ? value.trainee.rep_mother_name : value.trainee.mother_name,
                        value.trainee.rep_mobile ? value.trainee.rep_mobile : value.trainee.mobile,
                        value.trainee.trainee_age,
                        value.trainee.mouza.desc,
                        value.desc + '-' + 'Batch No.: ' + value.batch_no
                    ])
                })
            }
            catch (e) {
                console.log(e.message)
            }

            const doc = new jsPDF({ orientation: 'l'})
            autoTable(doc, {
                head: [['Form no', 'Name', 'Father/Husband name', 'Mother name', 'Mobile Number', 'Age', 'Mouza', 'Training Trade']],
                body: data,
            })
            doc.save('trainee-follow-up.pdf')
            this.spinner = false
            },
            async traineePDF(trainee, event){
                 this.traineePdf = trainee;
                await this.$refs.childRef.downloadPdf(event)
            },
            getCodes() {
                http.get("api/ses/codes").then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.villages = data.villages;
                        this.mouzas = data.mouzas;
                        this.trades = data.trades;
                    }
                });
            },
            search() {
                http.post("api/trainees/search/list", this.search_data).then(response => {
                    if (!response.error) {
                        this.flag = true;
                        this.trainees = response.data.trainees;
                    }
                });
            },
            getResults(page = 1) {
                http.post('api/trainees/search/list?page=' + page, this.search_data)
                    .then(response => {
                        this.flag = true;
                        this.trainees = response.data.trainees;
                    });
            },
            async fetchData() {
                const response = await http.post("api/followup/report/download", this.search_data);
                return response.data.trainees;
            },
            startDownload() {
                alert('It will take some time, Loading...');
            },
            finishDownload() {
                alert('Download completed.');
            },
            isVisible(row) {
                const matchedValue = this.checkboxArrays.find(
                    v => row === v
                );

                if (!matchedValue) {
                    return true;
                }
                return this.selected.includes(matchedValue);
            }
        },
        computed: {
            userPermission() {
                return this.$store.state.user
            }
        },
        created() {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>
